export default __webpack_public_path__ + "static/media/selfie.4130fcd4.jpg";